import { Link } from "react-router-dom";
import { useInView } from "../../../hooks/useInView";

export default function PromotionSection() {
  const { ref, inView } = useInView();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className="bg-zinc-900 py-16 md:py-24 relative overflow-hidden"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 bg-dot-grid-dark pointer-events-none" />
      {/* Big orange glow behind poster */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-orange-500/10 rounded-full blur-3xl pointer-events-none animate-glow-pulse" />
      {/* Diagonal accent corner */}
      <div className="absolute bottom-0 left-0 w-64 h-64 border-l border-b border-orange-500/15 pointer-events-none" />
      {/* Thin horizontal line accent */}
      <div className="absolute top-16 left-0 w-32 h-px bg-orange-500/30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Text Content */}
          <div className={`flex-1 w-full anim-hidden ${inView ? "animate-fade-in-left" : ""}`}>
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white font-condensed font-bold text-xs uppercase tracking-widest px-3 py-1 mb-6">
              <i className="ri-time-line text-sm" />
              Next Event
            </div>
            <h2 className="font-condensed font-black text-white uppercase text-4xl md:text-5xl lg:text-6xl leading-none mb-6 tracking-tight">
              Heavyweight<br />Championship<br />
              <span className="text-shimmer">Tournament</span>
            </h2>
            <p className="text-zinc-400 text-base leading-relaxed mb-8 max-w-md">
              Join our Heavyweight Championship Tournament and witness the best wrestlers battle it out for championship glory. A night of pure wrestling action you won&apos;t forget.
            </p>

            {/* Event meta */}
            <div className="flex flex-wrap gap-4 mb-8">
              <div className="flex items-center gap-2 text-zinc-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-calendar-line text-orange-500" />
                </div>
                <span className="font-condensed text-sm uppercase tracking-wide">July 13, 2025</span>
              </div>
              <div className="flex items-center gap-2 text-zinc-400">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-orange-500" />
                </div>
                <span className="font-condensed text-sm uppercase tracking-wide">Stanton, CA</span>
              </div>
            </div>

            <Link
              to="/events"
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-condensed font-bold text-sm uppercase tracking-widest px-7 py-3.5 transition-all duration-200 cursor-pointer whitespace-nowrap group"
            >
              Reserve Your Spot Today
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>

          {/* Event Poster */}
          <div
            className={`flex-shrink-0 w-full lg:w-auto flex justify-center anim-hidden ${inView ? "animate-fade-in-right delay-200" : ""}`}
          >
            <div className="w-72 md:w-80 lg:w-96 overflow-hidden relative">
              {/* Glow ring around poster */}
              <div className="absolute -inset-4 bg-orange-500/15 blur-2xl rounded-full pointer-events-none" />
              <div className="relative animate-float-y">
                <img
                  src="https://framerusercontent.com/images/dNTDjruMF3TCYJ4LZTtrsb3WtQ.png"
                  alt="Heavyweight Championship Tournament"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
